/* eslint-disable react/prop-types */
import { type FC, useState, forwardRef } from 'react';
import classNames from 'classnames/bind';
import GenericLink from '../GenericLink/GenericLink';
import { KeyConstants } from '../Accordion/types/enums';
import { type BreadcrumbProps } from './types/propTypes';
import styles from './Breadcrumb.module.scss';

const cx = classNames.bind(styles);

/**
 * @description Breadcrump Provides the display of all pages redirection.
 * Props ->
 * breadcrumbData  :  details of the state
 */
const Breadcrumb: FC<BreadcrumbProps> = forwardRef<HTMLUListElement, BreadcrumbProps>(({ breadcrumbData }, ref) => {
  const [isSliced, setIsSliced] = useState(true);
  const MAX_PAGES = 5;

  if (breadcrumbData.length < MAX_PAGES) {
    return (
      <ul
        className={styles['breadcrumb-navigation']}
        data-testid="breadcrumb-navigation"
        key="breadcrumb-navigation"
        ref={ref}
      >
        {breadcrumbData.map(function (crumb) {
          return (
            <li
              key={crumb.name}
              {...(crumb.link
                ? {}
                : {
                    'data-testid': 'breadcrumb-no-link',
                    className: styles['breadcrumb-no-link'],
                  })}
            >
              <GenericLink href={crumb.link || ''}>{crumb.name}</GenericLink>
            </li>
          );
        })}
      </ul>
    );
  }
  const getCls = (flag: boolean) =>
    cx({
      'breadcrumb-no-link': flag,
    });
  return (
    <ul
      onMouseLeave={() => setIsSliced(true)}
      className={styles['breadcrumb-navigation']}
      data-testid="breadcrumb-navigation"
      key="breadcrumb-navigation-sliced"
      aria-label="breadcrumb-list"
      ref={ref}
    >
      {isSliced ? (
        <button
          data-testid="breadcrum-ellipsis"
          key="breadcrum-ellipsis-item"
          onClick={() => setIsSliced(false)}
          onKeyDown={(e) => e.key === KeyConstants.ENTER && setIsSliced(false)}
          className={styles['breadcrumb-ellipsis']}
          aria-label="breadcrumb-item"
        >
          ...
        </button>
      ) : (
        breadcrumbData.slice(0, -2).map(function (crumb) {
          return (
            <li data-testid={crumb.link ? '' : 'breadcrumb-no-link'} className={getCls(!crumb.link)} key={crumb.name}>
              <GenericLink href={crumb.link || ''}>{crumb.name}</GenericLink>
            </li>
          );
        })
      )}
      <li
        data-testid={breadcrumbData[breadcrumbData.length - 2]?.link ? '' : 'breadcrumb-no-link'}
        className={getCls(!breadcrumbData[breadcrumbData.length - 2]?.link)}
        key="breadcrumb-no-link-2"
      >
        <GenericLink href={breadcrumbData[breadcrumbData.length - 2]?.link || ''}>
          {breadcrumbData[breadcrumbData.length - 2]?.name}
        </GenericLink>
      </li>
      <li key="breadcrumb-no-link-1">
        <GenericLink href={breadcrumbData[breadcrumbData.length - 1]?.link || ''}>
          {breadcrumbData[breadcrumbData.length - 1]?.name}
        </GenericLink>
      </li>
    </ul>
  );
});
Breadcrumb.displayName = 'Breadcrumb';
export type { BreadcrumbProps };
export default Breadcrumb;
